import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { Theme } from 'newCheckout/types/Theme'

const wrapperStyles = ({ theme }: Theme) => css`
  label: success-products__wrapper;

  margin-top: ${theme.spacings.tera};
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings.byte};
`
export const Wrapper = styled('div')(wrapperStyles)

const rowStyles = ({ theme }: Theme) => css`
  label: success-products__row;

  display: grid;
  align-items: baseline;
  grid-template-columns: 1fr;

  ${theme.media.mega} {
    grid-template-columns: 1fr 100px 150px;
  }
`
export const Header = styled('div')(rowStyles)

const itemInfostyle = ({ theme }: Theme) => css`
  label: success-products__item-info;

  padding: ${theme.spacings.mega} ${theme.spacings.giga} 0;

  background-color: ${theme.colors.n100};
  border-radius: ${theme.borderRadius.mega};

  &:not(:first-of-type) {
    margin-bottom: ${theme.spacings.giga};
  }

  ${theme.media.mega} {
    padding-bottom: ${theme.spacings.mega};
    padding-right: 0;

    &:not(:first-of-type) {
      margin-bottom: 0;
    }
  }
`
export const ItemInfo = styled('div')(itemInfostyle)

const itemPriceStyle = ({ theme }: Theme) => css`
  label: success-products__item-price;

  display: flex;
  align-items: end;

  border-radius: ${theme.borderRadius.mega};
`
export const ItemPrice = styled('div')(itemPriceStyle)

const inlineStyles = ({ theme }: Theme) => css`
  label: success-products__inline;

  display: flex;
  flex-direction: row;
  gap: ${theme.spacings.byte};
  align-items: top;

  ${theme.media.mega} {
    align-items: center;
  }
`
export const ResponsiveInline = styled('div')(inlineStyles)

const standlaloneServiceStyles = ({ theme }: Theme) => css`
  label: success-standaloneservice;

  align-items: stretch;

  background-color: ${theme.colors.n100};
  border-radius: ${theme.borderRadius.mega};
`

export const StandlaloneService = styled('div')(standlaloneServiceStyles)
